import styled from 'styled-components'

import Field from 'components/Form/components/Field'

export const DateFieldStyled = styled(Field)`
  &.error .Value {
    border: 1px solid ${({ theme }) => theme.color.error};
  }
`
